import type { AdminCrewReportStatisticsCardsProps } from "../../models/admin-crew-report.models";
import AdminCrewReportByDesksChart from "./AdminCrewReportByDesksChart";
import AdminCrewReportMonthsOnBoardChart from "./AdminCrewReportMonthsOnBoardChart";
import AdminCrewReportOver11MonthsChart from "./AdminCrewReportOver11MonthsChart";
import AdminCrewReportOverviewMetrics from "./AdminCrewReportOverviewMetrics";
import AdminCrewReportOwnerRepatriationChart from "./AdminCrewReportOwnerRepatriationChart";
import AdminCrewReportRepatriationTable from "./AdminCrewReportRepatriationTable";
import AdminCrewReportReportingCoverage from "./AdminCrewReportReportingCoverage";
import AdminCrewReportRunningVesselsChart from "./AdminCrewReportRunningVesselsChart";

const AdminCrewReportStatisticsCards = ({ statistics, view }: AdminCrewReportStatisticsCardsProps) => {
  const displayedStatistics = view === "women" ? statistics.womenOnBoard : statistics;

  if (!displayedStatistics) {
    return null;
  }

  return (
    <>
      <AdminCrewReportMonthsOnBoardChart statistics={displayedStatistics.monthsOnBoard} view={view} />
      <AdminCrewReportByDesksChart statistics={displayedStatistics.crewByDesks} view={view} />
      <AdminCrewReportOwnerRepatriationChart
        statistics={displayedStatistics.vesselsPerOwnerAndCrewRepatriation}
        view={view}
      />
      <AdminCrewReportOver11MonthsChart statistics={displayedStatistics.crewOver11Months} view={view} />
      <AdminCrewReportRunningVesselsChart statistics={displayedStatistics.runningVessels} view={view} />
      <AdminCrewReportRepatriationTable statistics={displayedStatistics.crewRepatriation} view={view} />
      <AdminCrewReportOverviewMetrics statistics={displayedStatistics.crewOverview} view={view} />
      {view === "women" && statistics.womenOnBoard ? (
        <AdminCrewReportReportingCoverage view="women" statistics={statistics.womenOnBoard.womenCoverage} />
      ) : (
        <AdminCrewReportReportingCoverage view="crew" statistics={statistics.reportedVessels} />
      )}
    </>
  );
};

export default AdminCrewReportStatisticsCards;
